import React from "react";
import { connect } from "react-redux";
import { Glyphicon } from "react-bootstrap";
import FirmwareModal from "./firmware-modal";
import { ElementStatus } from "./constant";

class AddFirmwareElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFirmwareModal: false,
      firmware: props.firmware,
      label: props.label,
      unitFamily: props.unitFamily,
    };

    this.closeFirmwareModal = this.closeFirmwareModal.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      firmware: {
        ...this.state.element,
        [event.target.id]: event.target.value,
      },
    });
  }

  closeFirmwareModal() {
    this.setState({ showFirmwareModal: false });
  }

  async onRowClick(item) {
    await this.setState({
      firmware: {
        ...this.state.firmware,
        fileName: item.fileName, //set selected firmware filename.
        isDeleted: false, //just incase, user have tried to removed the item, then we need to explicitly specify this element to False to make sure it is not Deleted.
      },
    });

    let selectedItem = {
      ...item,
      elementStatus: this.state.firmware.elementStatus,
      isDeleted: false,
    };

    this.props.onFirmwareSelected(selectedItem, this.props.path);
    this.closeFirmwareModal();
  }

  async RemoveFirmware() {
    await this.setState({
      firmware: {
        ...this.state.firmware,
        fileName: "", //clear filename.
        isDeleted:
          this.state.firmware.elementStatus == ElementStatus.NEW ? false : true, //isDeleted only applicable if status is Existing.
      },
    });

    this.props.onFirmwareRemoved(this.state.firmware, this.props.path);
  }

  render() {
    const { fileName } = this.state.firmware;
    return (
      <div className="container-fluid" style={{ paddingBottom: "2em" }}>
        <label>{this.state.label}</label>
        <div className="form-inline input-group col-xs-6">
          <input
            id="file"
            class="form-control"
            type="text"
            disabled
            onChange={this.handleChange}
            value={fileName}
          ></input>
          {(() => {
            let filename = this.state.firmware.fileName || ""; //set filename to empty string if Null.

            if (filename != "") {
              return (
                <span class="input-group-addon">
                  <a
                    style={{ cursor: "pointer", color: "relative" }}
                    onClick={() => this.RemoveFirmware()}
                    Title="Remove firmware"
                  >
                    <Glyphicon glyph="glyphicon glyphicon-remove"></Glyphicon>
                  </a>
                </span>
              );
            }
          })()}

          <span class="input-group-addon">
            <a
              id="btnfile"
              style={{ cursor: "pointer", color: "relative" }}
              onHide={this.closeFirmwareModal}
              onClick={() => this.setState({ showFirmwareModal: true })}
            >
              Browse
            </a>
          </span>
        </div>

        <FirmwareModal
          show={this.state.showFirmwareModal}
          onHide={this.closeFirmwareModal}
          onRowClick={this.onRowClick}
          unitFamily={this.state.unitFamily}
        />
      </div>
    );
  }
}

export default connect()(AddFirmwareElement);
